import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-937465e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "title_dialog" }
const _hoisted_3 = { class: "checkbox_wrap" }
const _hoisted_4 = { class: "checkbox_input" }
const _hoisted_5 = { class: "title_dialog" }
const _hoisted_6 = { class: "checkbox_wrap" }
const _hoisted_7 = { class: "function_checkbox_label" }
const _hoisted_8 = { class: "checkbox_input function_checkbox_wrap" }
const _hoisted_9 = { class: "event_icon" }
const _hoisted_10 = { class: "title_dialog" }
const _hoisted_11 = { class: "checkbox_wrap" }
const _hoisted_12 = { class: "checkbox_input" }

import { computed, withDefaults } from 'vue'
import { useStore } from 'vuex'
import DialogBase from '@/components/molecules/DialogBase'
import SimpleCheckbox from '@/components/atoms/SimpleCheckbox'
import APP from '@/js/const/app'
import { toCamelCase } from '@/js/utils/util'
import EventIcon from '@/components/atoms/EventIcon'
import type { ConditionDialogOption, ConditionDialogTag } from '../types'

type PropsType = {
  toggleDisplayState?: boolean
  selectedFunc?: string[]
  selectedTags?: string[]
  tags?: ConditionDialogTag[]
  selectedWatchStatus?: string
}


const __default__ = {
  name: 'ConditionDialog',
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    toggleDisplayState: { type: Boolean, default: false },
    selectedFunc: { default: () => [] },
    selectedTags: { default: () => [] },
    tags: { default: () => [] },
    selectedWatchStatus: null
  },
  emits: ["changeTags", "changeFunc", "changeDown", "update:toggleDisplayState", "update:selectedTags", "update:selectedFunc", "update:selectedWatchStatus", "search"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeTags', value: unknown): void
  (e: 'changeFunc', value: unknown): void
  (e: 'changeDown', value: unknown): void
  (e: 'update:toggleDisplayState', value: boolean): void
  (e: 'update:selectedTags', value: string[]): void
  (e: 'update:selectedFunc', value: string[]): void
  (e: 'update:selectedWatchStatus', value: string): void
  (e: 'search'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { toggleDisplayState: boolean, selectedFunc: string[], selectedTags: string[], tags: ConditionDialogTag[], selectedWatchStatus?: string };





const store = useStore()
const func: ConditionDialogOption[] = APP.FUNC(store.getters['app/settings'].environmentMode)
const down: ConditionDialogOption[] = APP.DOWN

const displayFlag = computed({
  get: () => props.toggleDisplayState,
  set: (newVal) => {
    if (props.toggleDisplayState !== newVal) {
      emit('update:toggleDisplayState', newVal)
    }
  },
})

const tagConditions = computed({
  get: () => props.selectedTags,
  set: (v) => {
    emit('update:selectedTags', v)
  },
})

const funcConditions = computed({
  get: () => props.selectedFunc,
  set: (v) => {
    emit('update:selectedFunc', v)
  },
})

const downConditions = computed({
  get: () => props.selectedWatchStatus,
  set: (v) => {
    if (v) {
      emit('update:selectedWatchStatus', 'down')
    } else {
      emit('update:selectedWatchStatus', '')
    }
  },
})

const zeroCamera = (v: unknown[] | undefined) => {
  return v === undefined || v.length === 0
}

const search = () => {
  emit('search')
  displayFlag.value = false
}

const eventIconType = (value: string) => {
  const event = value || ''
  return toCamelCase(event)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogBase), {
    modelValue: _unref(displayFlag),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(displayFlag) ? (displayFlag).value = $event : null)),
    onApprove: search,
    okBtnLabel: _ctx.$t('condition_dialog.okBtn')
  }, {
    title: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('condition_dialog.narrow_down')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('condition_dialog.tag')), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "checkbox_content",
              key: tag.tag_code
            }, [
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_unref(SimpleCheckbox), {
                  modelValue: _unref(tagConditions),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tagConditions) ? (tagConditions).value = $event : null)),
                  name: tag.tag_code,
                  value: tag.tag_code,
                  label: tag.tag_name,
                  disabled: zeroCamera(tag.cameras),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('changeTags', $event)))
                }, null, 8, ["modelValue", "name", "value", "label", "disabled"])
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["checkbox_content_camera_length", { zero_camera: zeroCamera(tag.cameras) }])
              }, "（" + _toDisplayString(tag.cameras.length) + "）", 3)
            ]))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('condition_dialog.function')), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(func), (f) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "checkbox_content",
              key: f.value
            }, [
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  _createVNode(_unref(SimpleCheckbox), {
                    modelValue: _unref(funcConditions),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(funcConditions) ? (funcConditions).value = $event : null)),
                    name: f.value,
                    value: f.value,
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (emit('changeFunc', $event))),
                    "data-test": `condition-dialog-checkbox-func-${f.value}`
                  }, null, 8, ["modelValue", "name", "value", "data-test"]),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_unref(EventIcon), {
                      "event-type": eventIconType(f.value)
                    }, null, 8, ["event-type"])
                  ]),
                  _createElementVNode("span", null, _toDisplayString(f.name), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('condition_dialog.status')), 1),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(down), (o) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "checkbox_content",
              key: o.value
            }, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_unref(SimpleCheckbox), {
                  modelValue: _unref(downConditions),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(downConditions) ? (downConditions).value = $event : null)),
                  name: o.value,
                  value: o.value,
                  label: o.name,
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (emit('changeDown', $event))),
                  "data-test": `condition-dialog-checkbox-status-${o.value}`
                }, null, 8, ["modelValue", "name", "value", "label", "data-test"])
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "okBtnLabel"]))
}
}

})